import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取角色员工列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含角色员工列表的Promise对象
 */
export function getRoleStaffList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/role.listRoleStaff',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取未关联的员工
 * @param {Object} params 查询参数
 * @returns {Promise} 包含未关联员工列表的Promise对象
 */
export function getNoRoleStaffs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/role.listStaffsNoRole',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 关联员工到角色
 * @param {Object} data 关联数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function saveRoleStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/role.saveRoleStaff',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 取消员工关联
 * @param {Object} data 取消关联数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function deleteRoleStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/role.deleteRoleStaff',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}